import { addDays, format } from "date-fns";
import subDays from "date-fns/subDays";

export interface lsd {
  day?: string;
  done?: boolean;
}

export function getLastSevenDays() {
  const lastSevenDaysKeys: lsd[] = [];
  //   const lastSevenDays = {};

  //   const result = format(addDays(Date.now(), 1), "MM/dd/yyyy");

  //   const yesterday = subDays(addDays(Date.now(), 1), 1);

  for (let i = 1; i < 8; i++) {
    const day = format(subDays(addDays(Date.now(), 1), i), "MM/dd/yyyy");
    lastSevenDaysKeys.push({ day, done: false });
  }

  return lastSevenDaysKeys;
}
